// Client-safe maps for /pests deep links. Deliberately tiny: client components
// (the diagnosis-results pest-guide link) must NOT import the full editorial
// module in data/pests/index.ts. A test asserts these stay in sync with
// PEST_PAGES.
//
// pestSlugForKey exists because the diagnosis flow emits PEST_CHARACTERISTICS
// ids, and white grubs are two ids ('white-grubs-japanese-beetle',
// 'white-grubs-european-chafer') sharing one page.

export const PEST_PAGE_SLUGS: Record<string, string> = {
  'white-grubs': 'White Grubs',
  'chinch-bugs': 'Chinch Bugs',
  'sod-webworms': 'Sod Webworms',
  armyworms: 'Armyworms',
  'mole-crickets': 'Mole Crickets',
  billbugs: 'Billbugs',
  'fire-ants': 'Fire Ants',
  'lawn-ants': 'Lawn Ants',
  cutworms: 'Cutworms',
  voles: 'Voles',
  moles: 'Moles',
}

const PEST_SLUG_BY_PEST_KEY: Record<string, string> = {
  'white-grubs-japanese-beetle': 'white-grubs',
  'white-grubs-european-chafer': 'white-grubs',
  'chinch-bugs': 'chinch-bugs',
  'sod-webworms': 'sod-webworms',
  armyworms: 'armyworms',
  'mole-crickets': 'mole-crickets',
  billbugs: 'billbugs',
  'fire-ants': 'fire-ants',
  ants: 'lawn-ants',
  cutworms: 'cutworms',
  voles: 'voles',
  moles: 'moles',
}

export function pestPageDisplayName(slug: string | undefined | null): string | undefined {
  return slug ? PEST_PAGE_SLUGS[slug] : undefined
}

/** PEST_CHARACTERISTICS id (a diagnosis `matchedSlug`) → /pests page slug. */
export function pestSlugForKey(key: string | undefined | null): string | undefined {
  return key ? PEST_SLUG_BY_PEST_KEY[key] : undefined
}
